import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import vSelect from 'vue-select';
import * as svgicon from 'vue-svgicon';
import Multiselect from 'vue-multiselect';
import vueMoment from 'vue-moment';
import moment from 'moment';
// import momentTimeZone from 'moment-timezone';
import PortalVue from 'portal-vue';
import Vuelidate from 'vuelidate';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import Circle2 from '@common/components/Spinner';
import Stretch from '@common/components/Stretch';
import Ellipsis from '@common/components/Ellipsis';
import amountToWords from '@common/utils/amountToWords';
import infiniteScroll from 'vue-infinite-scroll';
import infiniteLoading from 'vue-infinite-loading';
import VueProgress from 'vue-progress-path';
import vClickOutside from 'v-click-outside';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueSessionStorage from 'vue-sessionstorage';
import Hotjar from 'vue-hotjar';
import VueAnalytics from 'vue-analytics';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Tab from '@/components/common/tabs/Tab';
import Tabs from '@/components/common/tabs/Tabs';
import APP_CONSTANTS from '@common/utils/constants';
import menuOptionsUtils from '@common/utils/menuOptions';
import './element';
import features from './lib/features';
import ga from './lib/ga';
import permissionUtils from './lib/permission';
import numberIndianFormat from '../../common/utils/numberIndianFormat';
import Permission from './directives/permission';
import depot from './utils/depot';
import App from './App';

import i18n from './i18n';
import { autoLogout, autoLogOutTimeSet } from '@common/helpers/auto-logout';
import multiClickPrevent from '@common/helpers/multi-click-prevent';
import clarityInit from './plugins/clarity';
import preferredVolumeUnit from './utils/preferredVolumeUnit';

async function loadingVueJs(data) {
  /** Decryption */
  const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
  const bytes = CryptoJS.AES.decrypt(data, appSecret);
  const apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  await store.commit('app/ENVIRONMENT_DATA', apiData);

  const datepickerOptions = {};
  Vue.use(AirbnbStyleDatepicker, datepickerOptions);
  Vue.use(VueGoogleMaps, {
    load: {
      key: apiData.gm_key,
      libraries: 'places',
      installComponents: true,
    },
  });
  Vue.use(VueProgress, {
    // defaultShape: 'circle',
  });
  Vue.use(VueAnalytics, {
    id: apiData.ga_key,
    router,
    debug: {
      enabled: false,
      sendHitTask: Boolean(apiData.ga_key),
    },
  });
  Vue.component('v-select', vSelect);
  Vue.component('Tabs', Tabs);
  Vue.component('Tab', Tab);
  Vue.component('Spinner', Circle2);
  Vue.use(svgicon, { tagName: 'svgicon' });
  Vue.use(vueMoment, {
    moment,
  });
  // Vue.component('Select', Multiselect);
  Vue.component('Ellipsis', Ellipsis);
  Vue.component('Processing', Stretch);
  Vue.use(PortalVue);
  Vue.use(Vuelidate);
  Vue.use(infiniteScroll);
  Vue.use(infiniteLoading);
  Vue.use(vClickOutside);
  Vue.use(APP_CONSTANTS);
  Vue.use(VueSessionStorage);
  Vue.mixin(multiClickPrevent);
  if (apiData.hj_t_id) {
    Vue.use(Hotjar, {
      id: apiData.hj_t_id, // Hotjar Site ID
      isProduction: Boolean(apiData.hj_t_id),
    });
  }

  Permission.install();

  Vue.config.productionTip = false;
  Vue.prototype.$hasFeature = features;
  Vue.prototype.$depot = depot;
  Vue.prototype.$hasPermission = permissionUtils;
  Vue.prototype.$checkMenuOptions = menuOptionsUtils;
  Vue.prototype.$getIndianFormat = numberIndianFormat;
  Vue.prototype.$getWords = amountToWords;
  Vue.prototype.$addGAEvent = ga;
  Vue.prototype.$asset_path = process.env.VUE_APP_S3_PATH;
  Vue.prototype.$preferredVolumeUnit = preferredVolumeUnit;

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    i18n,
  });
    if(apiData.ms_clarity_projectId){
      // clarityInit(apiData.ms_clarity_projectId);
    }
}

async function run() {
  const hostname = window.location.host;
  const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
  const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';
  autoLogout(store);
  const axiosInstance = axios.create({ baseURL, timeout: 1800000 });
  let bootstrapResponse = '';
  axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('tsm-user-token');
    const isLogin = window.location.pathname === '/login';
    if ((token && token !== 'undefined')) { //  && !isLogin) {
      config.headers = { Authorization: `bearer ${token}` }; // eslint-disable-line
    }
    return config;
  }, error => Promise.reject(error));

  axiosInstance.interceptors.response.use((response) => {
    const token = response.headers['x-auth-token'];
    bootstrapResponse = response.headers['ui-session'];
    if (token) {
      localStorage.setItem('tsm-user-token', token);
    }
    autoLogOutTimeSet(response.status);
    return (response.data) ? response.data : response;
  }, error => Promise.reject(error.response));
  await axiosInstance.get('ui-bootstrap');
  loadingVueJs(bootstrapResponse);
}

run();

